import React from 'react'

const FormPlaceholder = () => (

  <div className='col-12 mt-1 px-2'>
    <div className='col-12 border-color-ui-3'>
      <div className='d-flex mt-2 align-items-center'>
        <div className='col-12'>
          <div className='row'>
            <div className='col-12 col-md mr-0 mr-md-1 mt-2 pt-5 bg-ui-4 radius' />
          </div>
        </div>
      </div>
    </div>
    <div className='row px-0 pb-2 pt-half border-bottom border-color-ui-3' />
  </div>

)

export default FormPlaceholder



// WEBPACK FOOTER //
// ./src/Participant/SecurityAccess/FormPlaceholder.js